<template>
    <div class="pageManager-m">
        <div class="jobMain">
            <div class="manager-rig">
                <div class="manager-rt" style="padding-bottom: 0;">
                    <div class="manager-rtle">考试管理</div>
                    <div class="manager-rtr">
                        <el-button size="medium" @click="downloadImportTemplate" :loading="templateLoading">
                            <i class="el-icon-download"></i> 下载导入模板
                        </el-button>
                        <el-button size="medium" type="primary" plain @click="triggerImportFile">
                            <i class="el-icon-upload2"></i> 导入 Excel
                        </el-button>
                        <input
                            ref="importFileInput"
                            type="file"
                            accept=".xlsx,.xls"
                            style="display: none;"
                            @change="onImportFileChange"
                        />
                        <el-button class="manager-rtr-export" size="medium" @click="exportAssignedExcel" :loading="exportLoading">
                            <i class="el-icon-download"></i> 导出数据
                        </el-button>
                    </div>
                </div>
                <div class="manager-rsubtle">为待分配考生维护考试信息（考场、座位、考试科目等）</div>
                <div class="exam-m1">
                    <el-row :gutter="24">
                        <el-col :span="8" v-for="(item,index) in boxList" :key="index">
                            <div class="exam-m1-box">
                                <div class="exam-m1-icon" :class="item.css"><i :class="item.icon"></i></div>
                                <div class="exam-m1-box-tle">{{ item.label }}</div>
                                <div class="exam-m1-box-num" :class="boxCss[index]">{{ item.num }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="exam-m2">
                    <div class="exam-m2-t">
                        <div class="exam-tab">
                            <ul>
                                <li v-for="(item,index) in tabs.tabList" :class="tabs.curTab===index ? 'active' : ''" :key="index" @click="tabClink(index)">{{ item.label }}({{ item.num }})</li>
                            </ul>
                        </div>
                        <div class="exam-tr">
                            <el-input v-model="examSearch" prefix-icon="el-icon-search" placeholder="搜索姓名" @input="getStudents"></el-input>
                        </div>
                    </div>
                    <div>
                        <table class="manager-exam-table">
                            <tr>
                                <th>姓名 / 身份证</th>
                                <th>专业</th>
                                <th>状态</th>
                                <th>维护信息</th>
                                <th width="15%">操作</th>
                            </tr>
                            <tbody v-for="(item,index) in students" :key="index">
                                <tr>
                                    <td>
                                        <div class="exam-td-name">{{item.applicantName}}</div>
                                        <div class="exam-td-icard">{{item.idCardNumber}}</div>
                                    </td>
                                    <td>{{item.positionName}}</td>
                                    <td><el-tag type="warning" size="mini"><i class="el-icon-warning-outline"></i> {{examStatus[item.status]}}</el-tag></td>
                                    <td>
                                        <div>{{item.examLocation}}</div>
                                        <div class="exam-td-icard">{{item.roomNumber ? ("第 " + item.roomNumber + " 考场") : ""}}{{item.seatNumber ? (" - " + item.seatNumber + "号") : ""}}</div>
                                    </td>
                                    <td>
                                        <el-button v-if="item.edit===0 && item.status===0" type="text" @click="stuEdit(index)"><i class="el-icon-edit"></i> 维护</el-button>
                                        <el-button v-if="item.edit===0 && item.status===1" type="text" @click="stuEdit(index)"><i class="el-icon-view"></i> 查看</el-button>
                                        <el-button v-if="item.edit===1" type="primary" icon="el-icon-arrow-up" size="mini" @click="stuEditClose(index)">收起</el-button>
                                    </td>
                                </tr>
                                <tr v-if="item.edit === 1">
                                    <td colspan="5" style="background: #FAFAFA;">
                                        <div class="exam-edit-box">
                                            <el-row :gutter="20">
                                                <el-col :span="6" v-if="item.status===0">
                                                    <div class="exam-form-t">考试地点</div>
                                                    <div class="exam-form-b">
                                                        <el-input placeholder="考试地点" size="medium" v-model="examObj.examLocation"></el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12" v-if="item.status===1">考试地点：{{ item.examLocation }}</el-col>
                                                <el-col :span="6" v-if="item.status===0">
                                                    <div class="exam-form-t">考场号</div>
                                                    <div class="exam-form-b">
                                                        <el-input placeholder="考场号" size="medium" v-model="examObj.roomNumber"></el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="6" v-if="item.status===1">考场号：{{ item.roomNumber }}</el-col>
                                                <el-col :span="6" v-if="item.status===0">
                                                    <div class="exam-form-t">座位号</div>
                                                    <div class="exam-form-b">
                                                        <el-input placeholder="座位号" size="medium" v-model="examObj.seatNumber"></el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="6" v-if="item.status===1">座位号：{{ item.seatNumber }}</el-col>
                                                <el-col :span="6">
                                                    <div class="exam-form-b" style="padding-top: 28px;" v-if="item.status===0">
                                                        <el-button type="primary" size="small" @click="addSubject"><i class="el-icon-plus"></i> 添加考试科目</el-button>
                                                    </div>
                                                </el-col>
                                                <el-col :span="24">
                                                    <div class="exam-form-t clearfix">
                                                        <span>考试科目安排</span>
                                                    </div>
                                                    <div class="exam-form-b" style="padding-bottom: 0;" v-if="item.status===0">
                                                        <div class="exam-subject" v-for="(v,i) in examObj.examScheduleList" :key="i">
                                                            <div class="exam-subject-li">
                                                                <el-row :gutter="10">
                                                                    <el-col :span="6">
                                                                        <el-input placeholder="" v-model="v.examSubject" size="small"></el-input>
                                                                    </el-col>
                                                                    <el-col :span="6">
                                                                        <el-date-picker v-model="v.examDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%;" size="small"></el-date-picker>
                                                                    </el-col>
                                                                    <el-col :span="5">
                                                                        <el-time-picker v-model="v.examTime" value-format="HH:mm:ss" placeholder="选择时间" size="small" style="width: 100%;"></el-time-picker>
                                                                    </el-col>
                                                                    <el-col :span="5">
                                                                        <el-time-picker v-model="v.examTimeEnd" value-format="HH:mm:ss" placeholder="选择时间" size="small" style="width: 100%;"></el-time-picker>
                                                                    </el-col>
                                                                    <el-col :span="2">
                                                                        <span class="exam-subject-del" @click="delSubject(i)"><i class="el-icon-delete"></i></span>
                                                                    </el-col>
                                                                </el-row>
                                                            </div>
                                                        </div>
                                                        <div class="exam-edit-action">
                                                            <el-button size="small" @click="stuEditClose(index)">取消</el-button>
                                                            <el-button type="primary" size="small" @click="saveEdit(item.id,index)">保存</el-button>
                                                        </div>
                                                    </div>
                                                    <div class="exam-form-b" style="padding-bottom: 0;" v-if="item.status===1">
                                                        <div class="exam-subject" v-for="(v,k) in item.examScheduleList" :key="k">
                                                            <div class="exam-subject-li">
                                                                <el-row :gutter="10">
                                                                    <el-col :span="6">{{ v.examSubject }}</el-col>
                                                                    <el-col :span="6">{{ v.examDate }}</el-col>
                                                                    <el-col :span="6">{{ v.examTime }}</el-col>
                                                                    <el-col :span="6">{{ v.examTimeEnd }}</el-col>
                                                                </el-row>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="导入预览确认"
            :visible.sync="importPreviewVisible"
            width="92%"
            top="4vh"
            custom-class="import-preview-dialog"
            @closed="resetImportPreview"
        >
            <div v-if="importParseErrors.length" class="import-error-box">
                <div class="import-error-title"><i class="el-icon-warning-outline"></i> 以下问题需修正后再导入：</div>
                <ul>
                    <li v-for="(err, idx) in importParseErrors" :key="'err-' + idx">{{ err }}</li>
                </ul>
            </div>
            <div v-else class="import-preview-wrap">
                <div class="import-preview-summary">
                    <span class="import-preview-summary-num">{{ importPreviewList.length }}</span>
                    <span>名考生待导入，请逐条核对考试地点与科目安排</span>
                </div>
                <div class="import-preview-list">
                    <div
                        v-for="(item, index) in importPreviewList"
                        :key="item.examAssignmentId || index"
                        class="import-preview-card"
                    >
                        <div class="import-preview-card-head">
                            <div class="import-preview-index">{{ index + 1 }}</div>
                            <div class="import-preview-main">
                                <div class="import-preview-name-row">
                                    <span class="import-preview-name">{{ item.applicantName || '—' }}</span>
                                    <span class="import-preview-id">分配ID {{ item.examAssignmentId }}</span>
                                </div>
                                <div class="import-preview-idcard">{{ item.idCardNumber || '—' }}</div>
                                <div class="import-preview-major">{{ item.positionName || '—' }}</div>
                            </div>
                            <div class="import-preview-place">
                                <div class="import-preview-place-item">
                                    <span class="label">考试地点</span>
                                    <span class="value">{{ item.examLocation || '—' }}</span>
                                </div>
                                <div class="import-preview-place-item">
                                    <span class="label">考场号</span>
                                    <span class="value">{{ item.roomNumber || '—' }}</span>
                                </div>
                                <div class="import-preview-place-item">
                                    <span class="label">座位号</span>
                                    <span class="value">{{ item.seatNumber || '—' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="import-preview-subjects">
                            <div class="import-preview-subjects-title">
                                考试科目安排
                                <el-tag size="mini" type="warning">{{ (item.examScheduleList || []).length }} 门</el-tag>
                            </div>
                            <div
                                v-for="(subject, sIdx) in item.examScheduleList"
                                :key="sIdx"
                                class="import-preview-subject-row"
                            >
                                <span class="import-subject-index">{{ sIdx + 1 }}</span>
                                <span class="import-subject-name">{{ subject.examSubject || '—' }}</span>
                                <span class="import-subject-date"><i class="el-icon-date"></i> {{ subject.examDate || '—' }}</span>
                                <span class="import-subject-time"><i class="el-icon-time"></i> {{ subject.examTime || '—' }} ~ {{ subject.examTimeEnd || '—' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="importPreviewVisible = false">取消</el-button>
                <el-button
                    type="primary"
                    :disabled="importParseErrors.length > 0 || !importPayload.length"
                    :loading="importSubmitting"
                    @click="confirmImport"
                >确认导入（{{ importPreviewList.length }} 人）</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";
import {
    downloadExamAssignedExport,
    downloadExamImportTemplate,
    parseExamImportWorkbook,
    readExamImportFile,
} from '../utils/examAssignmentImport';

export default {
    name: 'PageManagerExam',
    data() {
        return {
            boxList: [
                {label:'总考生数', num: 0, icon: 'el-icon-user', css: 'exam-m1-icon-blue'},
                {label: '已维护', num: 0, icon: 'el-icon-warning-outline', css: 'exam-m1-icon-green'},
                {label: '待维护', num: 0, icon: 'el-icon-suitcase-1', css: 'exam-m1-icon-yellow'}
            ],
            boxCss: {0: '', 1: 'green', 2: 'yellow'},
            tabs: {
                tabList: [
                    {label: '待分配', num: 0},
                    {label: '已分配', num: 0}
                ],
                curTab: 0,
            },
            examSearch: '',
            students: [],
            examStatus: {0: '待分配', 1: '已分配'},
            examObj: {
                examAssignmentId: null,
                roomNumber: '101',
                seatNumber: '01',
                examLocation: '集团培训中心',
                examScheduleList: [
                    {
                        examSubject: '专业技能',
                        examDate: moment(new Date()).format('yyyy-MM-DD'),
                        examTime: '09:00:00',
                        examTimeEnd: '11:30:00',
                    }
                ],
            },
            pendingStudents: [],
            templateLoading: false,
            exportLoading: false,
            importPreviewVisible: false,
            importPreviewList: [],
            importPayload: [],
            importParseErrors: [],
            importSubmitting: false,
        }
    },
    mounted() {
        document.title = '潞安招聘-考试管理';
        this.getCounts();
        this.getStudents();
    },
    methods: {
        tabClink: function (n) {
            this.tabs.curTab = n;
            this.getStudents();
        },
        getCounts: function () {
            axios.get('/zhaopinapi/exam-assignment/status-counts', {
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.boxList[0].num = 0;
                    _d.data.forEach(item => {
                        if(item.status === 0) {
                            this.tabs.tabList[0].num = item.count;
                            this.boxList[2].num = item.count;
                        } else if(item.status === 1) {
                            this.tabs.tabList[1].num = item.count;
                            this.boxList[1].num = item.count;
                        }
                        this.boxList[0].num += item.count;
                    })
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        getStudents: function () {
            axios.get('/zhaopinapi/exam-assignment/all', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {
                    status: this.tabs.curTab,
                    name: this.examSearch
                }
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    _d.data.forEach(item => {
                        item.edit = 0;
                    })
                    this.students = _d.data;
                    if (this.tabs.curTab === 0) {
                        this.pendingStudents = _d.data.slice();
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        fetchPendingStudents: function () {
            return axios.get('/zhaopinapi/exam-assignment/all', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: { status: 0, name: '' },
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    this.pendingStudents = data.data || [];
                    return this.pendingStudents;
                }
                return [];
            }).catch(() => []);
        },
        fetchAssignedStudents: function () {
            return axios.get('/zhaopinapi/exam-assignment/all', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {
                    status: 1,
                    name: this.examSearch || '',
                },
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    return data.data || [];
                }
                return [];
            }).catch(() => []);
        },
        exportAssignedExcel: function () {
            this.exportLoading = true;
            this.fetchAssignedStudents().then((list) => {
                if (!list.length) {
                    this.$message.warning('当前没有已分配考生可导出');
                    return;
                }
                downloadExamAssignedExport(list);
                this.$message.success(`已导出 ${list.length} 名已分配考生`);
            }).finally(() => {
                this.exportLoading = false;
            });
        },
        downloadImportTemplate: function () {
            this.templateLoading = true;
            this.fetchPendingStudents().then((list) => {
                if (!list.length) {
                    this.$message.warning('当前没有待分配考生，无法生成导入模板');
                    return;
                }
                downloadExamImportTemplate(list);
                this.$message.success('模板已下载，请在「考试安排」 sheet 中填写');
            }).finally(() => {
                this.templateLoading = false;
            });
        },
        triggerImportFile: function () {
            if (this.tabs.curTab !== 0) {
                this.$message.warning('请切换到「待分配」标签后再导入');
                return;
            }
            if (this.$refs.importFileInput) {
                this.$refs.importFileInput.value = '';
                this.$refs.importFileInput.click();
            }
        },
        onImportFileChange: function (event) {
            const file = event.target.files && event.target.files[0];
            if (!file) {
                return;
            }
            Promise.all([readExamImportFile(file), this.fetchPendingStudents()]).then(([workbook, pendingList]) => {
                const parsed = parseExamImportWorkbook(workbook, pendingList);
                this.importPreviewList = parsed.previewList;
                this.importPayload = parsed.payload;
                this.importParseErrors = parsed.errors;
                this.importPreviewVisible = true;
            }).catch((error) => {
                this.$message.error('解析 Excel 失败，请使用系统模板');
                console.log(error);
            });
        },
        resetImportPreview: function () {
            this.importPreviewList = [];
            this.importPayload = [];
            this.importParseErrors = [];
            this.importSubmitting = false;
        },
        confirmImport: function () {
            if (!this.importPayload.length || this.importParseErrors.length) {
                return;
            }
            this.importSubmitting = true;
            axios.post('/zhaopinapi/exam-assignment/import/batch', this.importPayload, {
                headers: {'Authorization': Cookies.get('reqToKen')},
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    const result = data.data || {};
                    const failCount = result.failCount || 0;
                    const successCount = result.successCount || 0;
                    if (failCount > 0) {
                        const errors = (result.errors || []).join('\n');
                        this.$alert(errors || '部分考生导入失败', '导入结果', { type: 'warning' }).catch(() => {});
                    } else {
                        this.$message.success(`成功导入 ${successCount} 名考生考试安排`);
                        this.importPreviewVisible = false;
                    }
                    this.getCounts();
                    this.getStudents();
                } else {
                    this.$message.error((data && data.message) || '导入失败');
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message) || '导入失败';
                this.$message.error(msg);
                console.log(error);
            }).finally(() => {
                this.importSubmitting = false;
            });
        },
        stuEdit: function (n) {
            this.students[n].edit = 1;
        },
        stuEditClose: function (n) {
            this.students[n].edit = 0;
        },
        addSubject: function () {
            this.examObj.examScheduleList.push({
                examSubject: '专业技能',
                examDate: moment(new Date()).format('yyyy-MM-DD'),
                examTime: '09:00:00',
                examTimeEnd: '11:30:00',
            })
        },
        delSubject: function (n) {
            this.examObj.examScheduleList.splice(n,1);
        },
        saveEdit: function (id,n) {
            this.examObj.examAssignmentId = id;
            axios.post('/zhaopinapi/exam-assignment/one', this.examObj,{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.$message.success('维护成功');
                    this.getCounts();
                    this.getStudents();
                    this.stuEditClose(n);
                } else {
                    this.$message.error((_d && _d.message) || '维护失败');
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message) || '维护失败';
                this.$message.error(msg);
                console.log(error)
            })
        },
    }
}
</script>

<style scoped>
    .pageManager-m{padding: 30px 0;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .manager-rig{}
    .manager-rt{height: 42px; padding-bottom: 18px;}
    .manager-rtle{font-size: 24px; line-height: 40px; float: left; font-weight: bold;}
    .manager-rsubtle{font-size: 12px; line-height: 20px; color: #99A1AF;}
    .manager-rtr{
        height: 40px;
        float: right;
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .manager-rtr-export{margin-left: 12px;}
    .exam-m1{padding: 20px 0;}
    .exam-m1-box{background: #FFF; border: 1px solid #e9e9eb; box-shadow: 0 3px 3px 0 #e9e9eb; padding: 16px; height: 50px; border-radius: 10px; position: relative;}
    .exam-m1-icon{padding: 8px; width: 20px; height: 20px; font-size: 20px; line-height: 20px; text-align: center; border-radius: 8px; margin-top: 7px; position: absolute; right: 20px; top: 15px;}
    .exam-m1-icon-blue{background: #ecf5ff; color: #409eff;}
    .exam-m1-icon-yellow{background: #fdf6ec; color: #e6a23c;}
    .exam-m1-icon-green{background: #f0f9eb; color: #67c23a;}
    .exam-m1-box-tle{font-size: 12px; line-height: 18px; color: #99A1AF;}
    .exam-m1-box-num{font-size: 24px; line-height: 32px; color: #000; font-weight: bold;}
    .blue{color: #409EFF;}
    .red{color: #E7000B;}
    .green{color: #67C23A;}
    .yellow{color: #E6A23C;}

    .exam-m2{background: #FFF; border-radius: 10px; border: 1px solid #e9e9eb; box-shadow: 0 3px 3px 0 #e9e9eb;}
    .exam-m2-t{padding: 16px 24px; border-bottom: 1px solid #D1D5DC;}
    .exam-tab{background: #f3f4f6; padding: 4px; border-radius: 6px; display: inline-block;}
    .exam-tab ul{margin: 0; padding: 0; list-style: none;}
    .exam-tab ul li{padding: 6px 12px; height: 20px; line-height: 20px; border-radius: 6px; display: inline-block; cursor: pointer; color: #6A7282;}
    .exam-tab ul li:hover{background: #eceef1; color: #3E3E3E;}
    .exam-tab ul li.active{background: #FFFFFF; color: #e6a23c; font-weight: bold;}
    .exam-tr{float: right; padding-left: 15px;}

    .manager-exam-table{width: 100%; border-collapse: collapse; border-spacing: 0; border-radius: 10px;}
    .manager-exam-table td{padding: 10px 20px; line-height: 20px !important; background: #fff; border-bottom: 1px solid #e9e9eb;}
    .manager-exam-table th{padding: 15px 20px; line-height: 20px; background: #f9fafb; border-bottom: 1px solid #e9e9eb; text-align: left;}
    .manager-exam-table tr:hover td{background: #f9fafb;}
    .exam-td-name{font-weight: bold; line-height: 20px; color: #3E3E3E; font-size: 14px;}
    .exam-td-icard{line-height: 20px; color: #99A1AF; font-size: 12px;}
    .exam-edit-box{background: #FFF; border: 1px solid #e9e9eb; border-radius: 10px; padding: 16px;}
    .exam-form-t{font-size: 14px; line-height: 20px; padding-bottom: 5px;}
    .exam-form-b{padding-bottom: 16px;}
    .exam-subject{padding: 12px 12px 0 12px; border-radius: 10px; background: #f9fafb; border: 1px solid #D1D5DC; margin-bottom: 5px; position: relative;}
    .exam-subject-li{padding-bottom: 12px;}
    .exam-subject-del{color: #99A1AF; font-size: 16px; width: 16px; float: right; cursor: pointer; margin-top: 5px;}
    .exam-subject-del:hover{color: #E7000B;}
    .exam-edit-action{border-top: 1px solid #e9e9eb; padding-top: 15px; text-align: right;}
    .import-preview-tip{margin-bottom: 12px; color: #4A5565; font-size: 13px;}
    .import-error-box{border: 1px solid #FDE68A; background: #FFFBEB; border-radius: 8px; padding: 12px 16px; max-height: calc(85vh - 160px); overflow: auto;}
    .import-error-title{font-weight: bold; color: #92400E; margin-bottom: 8px;}
    .import-error-box ul{margin: 0; padding-left: 18px; color: #92400E;}
    .import-preview-wrap{display: flex; flex-direction: column; min-height: 420px;}
    .import-preview-summary{display: flex; align-items: center; gap: 8px; margin-bottom: 16px; padding: 12px 16px; border-radius: 10px; background: #EFF6FF; border: 1px solid #DBEAFE; color: #1E3A8A; font-size: 14px;}
    .import-preview-summary-num{font-size: 22px; font-weight: bold; color: #E7000B; line-height: 1;}
    .import-preview-list{max-height: calc(85vh - 220px); overflow: auto; padding-right: 4px;}
    .import-preview-card{border: 1px solid #E5E7EB; border-radius: 12px; background: #FFF; margin-bottom: 16px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.06);}
    .import-preview-card:last-child{margin-bottom: 0;}
    .import-preview-card-head{display: flex; gap: 16px; padding: 16px 18px; background: #F9FAFB; border-bottom: 1px solid #E5E7EB;}
    .import-preview-index{flex: 0 0 32px; height: 32px; line-height: 32px; text-align: center; border-radius: 50%; background: #E7000B; color: #fff; font-weight: bold; font-size: 14px;}
    .import-preview-main{flex: 1; min-width: 0;}
    .import-preview-name-row{display: flex; align-items: center; gap: 10px; flex-wrap: wrap;}
    .import-preview-name{font-size: 18px; font-weight: bold; color: #111827;}
    .import-preview-id{font-size: 12px; color: #6B7280; background: #E5E7EB; border-radius: 4px; padding: 2px 8px;}
    .import-preview-idcard{margin-top: 4px; font-size: 13px; color: #6B7280; font-family: Consolas, monospace;}
    .import-preview-major{margin-top: 6px; font-size: 13px; color: #374151;}
    .import-preview-place{flex: 0 0 220px; display: flex; flex-direction: column; gap: 8px;}
    .import-preview-place-item{display: flex; flex-direction: column; gap: 2px;}
    .import-preview-place-item .label{font-size: 12px; color: #9CA3AF;}
    .import-preview-place-item .value{font-size: 14px; color: #111827; font-weight: 600; word-break: break-all;}
    .import-preview-subjects{padding: 14px 18px 16px;}
    .import-preview-subjects-title{display: flex; align-items: center; gap: 8px; margin-bottom: 10px; font-size: 14px; font-weight: bold; color: #374151;}
    .import-preview-subject-row{display: flex; align-items: center; gap: 12px; padding: 10px 12px; margin-bottom: 8px; border-radius: 8px; background: #FAFAFA; border: 1px solid #F3F4F6;}
    .import-preview-subject-row:last-child{margin-bottom: 0;}
    .import-subject-index{flex: 0 0 24px; height: 24px; line-height: 24px; text-align: center; border-radius: 6px; background: #FEF2F2; color: #E7000B; font-size: 12px; font-weight: bold;}
    .import-subject-name{flex: 0 0 140px; font-weight: 600; color: #111827; font-size: 14px;}
    .import-subject-date{flex: 0 0 130px; color: #4B5563; font-size: 13px;}
    .import-subject-time{flex: 1; color: #4B5563; font-size: 13px; min-width: 180px;}
    .import-subject-date i,.import-subject-time i{margin-right: 4px; color: #9CA3AF;}

    /deep/ .import-preview-dialog{max-width: 1280px; margin-top: 4vh !important;}
    /deep/ .import-preview-dialog .el-dialog__body{padding: 16px 24px 8px; max-height: calc(92vh - 130px); overflow: hidden;}
    /deep/ .import-preview-dialog .el-dialog__header{padding: 16px 24px 10px; border-bottom: 1px solid #F3F4F6;}
    /deep/ .import-preview-dialog .el-dialog__title{font-size: 18px; font-weight: bold;}
    /deep/ .import-preview-dialog .el-dialog__footer{padding: 12px 24px 16px; border-top: 1px solid #F3F4F6;}

    /deep/ .el-dialog{border-radius: 12px;}
    /deep/ .el-dialog .el-dialog__header{background: #f9fafb !important; border-top-left-radius: 12px; border-top-right-radius: 12px;}
    /deep/ .el-dialog .el-dialog__footer{background: #f9fafb !important; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; padding: 10px 20px;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
